import '@connectedhomes/nucleus/nucleus.min.js';
import { hijackEffects } from 'stop-runaway-react-effects';

import { initDataDogRUM } from 'analytics/initDataDogRUM';

const { NODE_ENV } = process.env;

/* istanbul ignore next -- @preserve */
if (window.self !== window.top) {
  throw new Error('Embedding in an iframe is not allowed.');
}

if (NODE_ENV !== 'production') {
  hijackEffects();
}

initDataDogRUM();

document.body.classList.add('ndsn'); // add nucleus namespace ...
